export function isAccessedInIframe() {
    return window.self !== window.top;
}